module.exports = __webpack_public_path__ + "f9ea3b437ef3ad63d11641488d0a72cf.svg";